var module = angular.module('octopusApp.projects');

module.controller('ProjectVariableTemplatesController', function($scope, busy, pageTitle, projectState, octopusRepository, octopusPermissionSet, templateParameterModal, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var projectId = projectState.projectId;
    $scope.unsavedChanges = unsavedChanges;
    $scope.templateEditor = null;

    var load = function()
    {
        isLoading.promise(projectState.load().then(function(project) {
            pageTitle(project.Name + ' Variable Templates');
            $scope.templateEditor = templateParameterModal.create(project.Templates, { name: 'Project Variable Template', isTemplate: true, requiredPermission: 'VariableEdit', projectId: project.Id });

            isLoading.promise(octopusPermissionSet.isAuthorized({ permission: 'VariableEdit', projectId: project.Id, environmentId: '*' }).then(function(yn){
                $scope.project = project;

                $scope.save = function() {
                    isSaving.promise(octopusRepository.Projects.get(projectId).then(function(project) {
                        project.Templates = $scope.project.Templates;
                        return octopusRepository.Variables.modify($scope.project).then(function() {
                            unsavedChanges.saved();
                            load();
                        });
                    }));
                };
            }));
        }));
    };

    load();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_templates.js
// module id = 579
// module chunks = 1